import React, { useState } from "react";
import { BsArrowLeft } from "react-icons/bs";
import { formatAmount } from "../../../utils/formatTime";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { API } from "../../../constants/api";
import useAuthAxios from "../../../utils/baseAxios";
import { errorMessage } from "../../../utils/errorMessage";
import ClipLoader from "react-spinners/ClipLoader";
import OtpPin from "../../../components/OtpPin";
import { useUser } from "../../../context/user-context";
import { truncateWord } from "../../../utils/wordFunctions";
import { getNetworkLabel } from "../../../constants/constants";
import { invalidateActivityQueries } from "../../../utils/invalidateActivityQueries";

const ExternalPreview = ({
  setOpenWithdrawExWallet,
  setOpenWithdrawPreviewEx,
  setOpenSuccess,
  network,
  selectedCoinObjw,
  fee,

  exWalletAddy,
  amount,
}: any) => {
  const { refetch } = useUser();
  const queryClient = useQueryClient();
  const [addPin, setAddPin] = useState<boolean>(false);
  const [otp, setOtp] = useState<string>("");

  const axiosInstance = useAuthAxios();

  const sendCrypto = async ({ asset, amount, wallet, network, pin }: any) => {
    const response = await axiosInstance.post(API.withdrawAsset, {
      asset,
      amount,
      wallet,
      network,
      pin,
    });
    return response.data;
  };

  const completeSendCrypto = useMutation({
    mutationFn: sendCrypto,
    onSuccess: (r) => {
      toast.success(r.message);
      invalidateActivityQueries(queryClient);
      queryClient.invalidateQueries({ queryKey: ["userDetails"] });
      setTimeout(() => {
        setOpenWithdrawPreviewEx(false);
        setOpenSuccess(true);
        refetch();
      }, 2000);
    },
    onError: (e) => {
      // console.log(e);
      const err = e as any;
      toast.error(errorMessage(err?.message || err?.data?.message));
    },
  });

  return (
    <div className="fixed inset-0   flex font-manrope justify-start items-start pt-16 overflow-auto pb-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        <div className="w-full flex justify-start gap-6 items-center">
          <button
            onClick={() => {
              setOpenWithdrawPreviewEx(false);
              setOpenWithdrawExWallet(true);
            }}
            className="flex items-center gap-2 "
          >
            <BsArrowLeft className="dark:text-[#D8D8D8] text-gray-800 text-[12px]" />
          </button>
          <h4 className="text-gray-900 dark:text-gray-100 font-sora font-semibold text-[20px]">
            Preview Withdraw
          </h4>
        </div>
        {addPin ? (
          <div className="mt-12">
            <h4 className="text-gray-900 text-center dark:text-gray-100 font-sora mb-4 font-semibold text-[20px]">
              Enter transaction PIN
            </h4>
            <OtpPin otp={otp} input={4} setOtp={setOtp} />
            <button
              onClick={() => {
                completeSendCrypto.mutate({
                  asset: selectedCoinObjw?.abbr.toUpperCase(),
                  amount: Number(amount),
                  wallet: exWalletAddy,
                  network: network.toUpperCase(),
                  pin: otp,
                });
              }}
              disabled={otp.length !== 4 || completeSendCrypto.isPending}
              className={
                otp.length !== 4
                  ? "mt-44 bg-gray-400 flex justify-center items-center text-gray-200 font-medium w-full h-[52px] rounded-xl"
                  : "mt-44 bg-secondary_button flex justify-center items-center text-white font-medium w-full h-[52px] rounded-xl"
              }
            >
              {completeSendCrypto.isPending ? (
                <ClipLoader color="#ffffff" size={20} />
              ) : (
                "Proceed"
              )}
            </button>
          </div>
        ) : (
          <div className="w-full mt-4">
            <div className=" border-b border-gray-200 dark:border-gray-600 py-5">
              <h4 className="text-secondary_button text-[13px] font-bold">
                Amount
              </h4>
              <h4 className="mt-2 text-[16px] text-[#13181B] dark:text-gray-100 ">
                {formatAmount(amount)} {selectedCoinObjw?.abbr}
              </h4>
            </div>
            <div className=" border-b border-gray-200 dark:border-gray-600 py-5">
              <h4 className="text-secondary_button text-[13px] font-bold">
                Coin
              </h4>
              <h4 className=" mt-2 text-[16px] text-[#13181B] dark:text-gray-100">
                {selectedCoinObjw?.name} {selectedCoinObjw?.abbr}
              </h4>
            </div>
            <div className=" border-b border-gray-200 dark:border-gray-600 py-5">
              <h4 className="text-secondary_button text-[13px] font-bold">
                Network
              </h4>
              <h4 className=" mt-2 text-[16px] uppercase text-[#13181B] dark:text-gray-100">
                {getNetworkLabel(network)}
              </h4>
            </div>
            <div className=" border-b border-gray-200 dark:border-gray-600 py-5">
              <h4 className="text-secondary_button text-[13px] font-bold">
                Receipient address{" "}
              </h4>
              <h4 className=" mt-2 text-[16px] text-[#13181B] dark:text-gray-100">
                {truncateWord(exWalletAddy)}
              </h4>
            </div>

            <div className=" border-b border-gray-200 dark:border-gray-600 py-5">
              <h4 className="text-secondary_button text-[13px] font-bold">
                Network Fee
              </h4>
              <h4 className=" mt-2 text-[16px] text-[#13181B] dark:text-gray-100">
                {formatAmount(fee)} {selectedCoinObjw?.abbr}
              </h4>
            </div>
            <div className=" border-b border-gray-200 dark:border-gray-600 py-5">
              <h4 className="text-secondary_button text-[13px] font-bold">
                Total amount to receive
              </h4>
              <h4 className=" mt-2 text-[20px] text-[#13181B] dark:text-gray-100 font-sora font-bold">
                {formatAmount(Math.max(0, Number(amount) - Number(fee)))} {selectedCoinObjw?.abbr}
              </h4>
            </div>
            <button
              onClick={() => {
                // setOpenPreview(false);
                // setOpenSellPending(true);
                setAddPin(true);
              }}
              className="mt-12 bg-secondary_button flex justify-center items-center text-white text-[15px] font-medium h-[52px] w-full rounded-xl"
            >
              Send {selectedCoinObjw?.abbr}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ExternalPreview;
